export const environment = {
  production: false,
  CLIENT_BASE_URL: 'https://d1aczabmblwch8.cloudfront.net/prod/client/api',

  FILE_BASE_URL:
    'https://mango-public-storage-prod.s3.eu-central-1.amazonaws.com',

  // TODO: This Firebase config points at the `mamvest-dev` project (same as the dev environment). Unless the projectId for Prod is mamvest-dev. maybe mamvest-pod?
  firebase: {
    apiKey: "AIzaSyBHTUwIJCCsABR1h0dKcPbQtTMBJgAzMAg",
    authDomain: "mamvest-dev.firebaseapp.com",
    projectId: "mamvest-dev",
    storageBucket: "mamvest-dev.firebasestorage.app",
    messagingSenderId: "927673991189",
    appId: "1:927673991189:web:603cce4649746bd4504e1c",
    vapidKey: "BIaf35XCpJSmo7Vd5AH2CyHf8d0z2542IrgzkGWVKlXlSUl0wu9ILqC65wtUhkMlghk02tw9F8XLF0xeFN_5zqA"
  }
};


